import React from 'react';
import { Box, Grid, Typography, Avatar } from '@mui/material';
import PetsIcon from '@mui/icons-material/Pets';
import { formatDateReplaceHour } from '../utils/lib';
import { useTranslation } from 'react-i18next';
import { useConfig } from '../providers/ConfigProvider';

const ListItemPet = ({ pet }) => {
  const { t } = useTranslation();
  const { config } = useConfig();
  const ownersText = pet.owners?.map(owner => owner.name).join(', ') || '';

  return (
    <Box
      sx={{ 
        px: 2, 
        py: 1, 
        display: 'flex', 
        flexDirection: 'column', 
        width: '100%',
        borderRadius: 1,
        bgcolor: 'background.paper',
      }}
    >
      <Grid container spacing={2} alignItems="center">
        {/* Thumbnail */}
        <Grid item>
          <Avatar 
            sx={{ width: 56, height: 56, bgcolor: 'grey.800' }} 
            alt="Thumbnail"
            src={pet.thumb_url}
          >
            {!pet.thumb_url && <PetsIcon sx={{ fontSize: 32 }} />}
          </Avatar>
        </Grid>
        
        {/* Name and Owners */}
        <Grid item xs>
          <Typography 
            variant="subtitle1" 
            noWrap
          >
            {pet.name}
          </Typography>
          {ownersText && (
            <Typography 
              variant="body2" 
              color="text.secondary"
              noWrap
              sx={{ mb: 0.5 }}
            >
              {t('layouts.fromOwner')} {ownersText}
            </Typography>
          )}
          {pet.breed && (
            <Typography 
              variant="body2" 
              color="text.secondary"
              noWrap
            >
              {pet.breed}
            </Typography>
          )}
        </Grid>

        {/* Age/Birthday Info */}
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-end',
            textAlign: 'right',
          }}
        >          
          <Typography 
            variant="caption" 
            noWrap
          >
            {pet.birth_date && formatDateReplaceHour(pet.birth_date, config)}
          </Typography>
          <Typography 
            variant="caption" 
            noWrap
          >
            {pet.age_text || pet.age || ''}
          </Typography>
        </Box>
      </Grid>
    </Box>
  );
};

export default ListItemPet; 